import * as ActionTypes from "../constants/actionTypes";

export function fetchCaptcha() {
    return function(dispatch) {
        return fetch(`${process.env.REACT_APP_API_ENDPOINT}EDM/Captcha`)
          .then(response => response.json())
          .then(json => {
              dispatch({ type: ActionTypes.FETCH_CAPTCHA, payload: json });
          });
    }
}

export function submitEDM(payload) {
    return async function(dispatch) {
        try {
            const response  = await fetch(process.env.REACT_APP_API_ENDPOINT + "EDM/SubmitEDM/", { 
                    method: 'POST',        
                    body: JSON.stringify(payload),
                    cache: 'no-cache',
                    credentials: 'same-origin',
                    headers: {'content-type': 'application/json'},
                });
            if (response.status !== 200) {
                dispatch({ type: ActionTypes.FETCH_CAPTCHA_CHECK, payload: false });
                return false;
            } else {
                const json = await response.json();
                dispatch({ type: ActionTypes.SUBMIT_EDM, payload: json });
                return true;
            }
        } catch(e) {
            dispatch({ type: ActionTypes.FETCH_CAPTCHA_CHECK, payload: false });
            return false;
        }
    };
}

export function fetchChannel(payload) {
    return function(dispatch) {
        dispatch({ type: ActionTypes.FETCH_CHANNEL, payload: payload });
    }
}
